// Reports/Resultados/Report/ResultadosReport.js
import React, { Component } from "react";
import LoadMask from "Utils/LoadMask/LoadMask";
import CardFormNoBorder from "Utils/Cards/CardFormNoBorder";
import Tabs, { TabPane } from "rc-tabs";
import ResultadosForm from "./ResultadosForm";
import ResultadosFormAnnual from "../ReportAnnual/ResultadosForm";
import Modal from "./utils/Modal/Modal";
import ModalAnnual from "../ReportAnnual/utils/Modal/Modal";
export default class ResultadosReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openAnnual: false,
            initialValues: {},
        };
    }
    componentDidMount() {
        if (this.props.tab === "RESULTADOS") {
            this.props.getResultados();
        } else {
            this.props.getResultadosAnuales();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.tab !== prevProps.tab) {
            if (this.props.tab === 'RESULTADOS') {
                this.props.getResultados();
            } else {
                this.props.getResultadosAnuales();
            }
        }
    }

    actualizar = (data) => {
        const dataSave = {
            ...data,
            isDollar: this.props.currency === "USD",
        };
        this.props.editar(null, dataSave);
    };

    openModal = () => {
        this.setState({ open: true });
    };

    openModalAnnual = () => {
        this.setState({ openAnnual: true });
    };

    closeModal = () => {
        this.setState({ open: false });
    };

    closeModalAnnual = () => {
        this.setState({ openAnnual: false });
    };

    actualizarModal = (data) => {
        this.props.editarModal(data.sales_data[0].id, data);
        this.closeModal();
    };

    actualizarModalAnnual = (data) => {
        this.props.editarModalAnnual(undefined, data);
        this.closeModalAnnual();
    };

    openAndConsultModal = () => {
        this.props.getSalesCostConfig();
        this.openModal();
    };

    openAndConsultModalAnnual = () => {
        this.props.getSalesCostConfigAnnual();
        this.openModalAnnual();
    };

    render() {
        const { tab, setTab, loader, item, data } = this.props;

        return (
            <div className="mb-4 col-12">
                <CardFormNoBorder
                    icon="Side_activos/finca.svg"
                    titulo="REPORTE DE RESULTADOS"
                    subtitulo="RESULTADOS"
                    subtituloForm="VER"
                    col="12"
                    noShadow
                ></CardFormNoBorder>
                <Tabs
                    defaultActiveKey={tab}
                    onChange={setTab}
                    animated={{ tabPane: true, inkBar: true }}
                >
                    <TabPane tab="RESULTADOS" key="RESULTADOS">
                        <LoadMask loading={loader} blur> 
                            <ResultadosForm
                                onSubmit={this.actualizar}
                                item={item}
                                openAndConsultModal={this.openAndConsultModal}
                                {...this.props}
                            />
                            <Modal
                                onSubmit={this.actualizarModal}
                                open={this.state.open}
                                closeModal={this.closeModal}
                                {...this.props}
                            />
                        </LoadMask>
                    </TabPane>
                    <TabPane tab="RESULTADOS ANUALES" key="RESULTADOS_ANUALES">
                        <LoadMask loading={loader} blur>
                            <ResultadosFormAnnual
                                item={item}
                                openAndConsultModal={this.openAndConsultModalAnnual}
                                {...this.props}
                            />
                            <ModalAnnual
                                onSubmit={this.actualizarModalAnnual}
                                open={this.state.openAnnual}
                                closeModal={this.closeModalAnnual}
                                {...this.props}
                            />
                        </LoadMask>
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}
